import { writable } from 'svelte/store';
export const timestampOptimizer = (timestamps) => {
    const newTimestamp = [];
    const maxTimeDifferenceInSeconds = 2.0;
    if (timestamps.length <= 1)
        return timestamps;
    for (let i = 1; i < timestamps.length; i++) {
        const firstTimestamp = timestamps[i - 1];
        const secondTimestamp = timestamps[i];
        const difference = Math.abs(secondTimestamp.startDuration - firstTimestamp.endDuration);
        if (difference >= 0 && difference <= maxTimeDifferenceInSeconds) {
            const combinedTimestamp = newTimestamp.pop() || {
                startDuration: firstTimestamp.startDuration,
                endDuration: secondTimestamp.endDuration
            };
            combinedTimestamp.endDuration = secondTimestamp.endDuration;
            newTimestamp.push(combinedTimestamp);
        }
        else {
            if (firstTimestamp && i === 1)
                newTimestamp.push(firstTimestamp);
            newTimestamp.push(secondTimestamp);
        }
    }
    return newTimestamp;
};
const instance = writable({});
export default instance;
export const currentFrame = writable(0);
